<template>
  <div class="onboarding_page">
    <h2>Kan era medlemmar vara minderåriga?</h2>
    <p>Ifall ni har medlemmar som är under 18 år måste ni svara Ja på denna.</p>
    <div class="segmented_select_container">
      
      <memlist-segmented-select-button 
        :parts="minor_options"
        :primary_color="'rgb(0 123 255)'"
        :secondary_color="'#ffffff'"
        :preselected_index="preselected_index"
        @selected="on_selection"
      />
      
    </div>
   
    <div class="wizard_actions mt-4">
      <memlist-button variant="secondary" @click="prev_page">Tillbaka</memlist-button>
      <memlist-button variant="primary" :disabled="disabled_next" class="ml-8" @click="next_page">Fortsätt</memlist-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'onboarding_page3',
  props: ['onboarding_data'],
  emits: ['next_page','prev_page','update_data'],
  watch: {
    onboarding_data: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_onboarding_data = { ...this.onboarding_data };
        this.selected_option = this.local_onboarding_data.minor_possible;

        const index = this.minor_options.findIndex(i => i.value === this.selected_option);
        if (index >= 0) {
          this.preselected_index = index;
        }
      },
      immediate: true
    },
  },
  computed: {
    disabled_next() {
      return !this.selected_option;
    },
  },
  data() {
    return {
      preselected_index: null,
      minor_options: [
        { value: 'ja', text: 'Ja' },
        { value: 'nej', text: 'Nej' },
        { value: 'vet_ej', text: 'Vet ej' }
      ],
      selected_option: ''
    }
  },
  methods: {
    on_selection(value) {
      this.selected_option = value
    },
    next_page() {
      this.local_onboarding_data.has_minor_shown = true;
      this.local_onboarding_data.minor_possible = this.selected_option;

      this.$emit('update_data', this.local_onboarding_data);
      this.$emit('next_page');
    },
    prev_page() {
      this.$emit('prev_page');
    }
  }
}
</script>

<style lang="scss" scoped>


.segmented_select_container {
  margin: 20px 0;
}

</style>
